<!-- card-details.component.html -->
<!-- <h2 class="card-title">Choose a card</h2>
 -->
<div class="card-details-container">
  <div class="card-selection-container">
    <div
      *ngFor="let card of cards"
      #cardOption
      [id]="'card-' + card.id"
      class="card-option"
      [class.selected]="selectedCard === card.id"
      (click)="selectCard(card.id)"
    >
      <div class="radio-button">
        <p class="title" [ngClass]="{ red: card.isNew }">{{ card.bankName }}</p>
        <mat-radio-button
          disableRipple="true"
          [checked]="selectedCard === card.id"
        ></mat-radio-button>
      </div>
      <div class="card-content">
        <p>{{ card.isNew ? 'Use a new card' : card.maskedNumber }}</p>
        <div class="card-icons">
          <img
            *ngIf="card.type === 'visa' || 'new'"
            src="assets/icons/Visa.svg"
            alt="Visa"
          />
          <img
            *ngIf="card.type === 'mastercard' || 'new'"
            src="assets/icons/Mastercard.svg"
            alt="Mastercard"
          />
          <img
            *ngIf="card.type === 'amex' || 'new'"
            src="assets/icons/AMEX.svg"
            alt="American Express"
          />
          <img
            *ngIf="card.type === 'discover' || 'new'"
            src="assets/icons/Discover.svg"
            alt="Discover"
          />
        </div>
      </div>
    </div>
  </div>
</div>

<h3 class="card-title">Card Details</h3>

<!-- Show all fields if "New Card" is selected, otherwise show only Expiration date and Security code -->
<div class="card-details" [formGroup]="cardForm">
  <mat-form-field *ngIf="isCardNew()" appearance="fill">
    <mat-label>Name on card</mat-label>
    <input
      matInput
      [formControl]="nameOnCard"
      placeholder="Type name on card"
      autocomplete="cc-name"
      (input)="onInputName($event)"
    />
    <div matSuffix tabindex="-1" class="p-r-m">
      <mat-icon>
        <i class="healent-avatar-solid primary-color"></i>
      </mat-icon>
    </div>
    <mat-error style="font-size: 12px">Valid name required</mat-error>
  </mat-form-field>
  <mat-form-field *ngIf="isCardNew()" appearance="fill">
    <mat-label>Card number</mat-label>
    <input
      matInput
      [formControl]="accountnumber"
      placeholder="1234 5678 9012 3456"
      type="tel"
      (input)="onCardNumberInput($event)"
    />
    <div matSuffix tabindex="-1" class="p-r-m">
      <img
        [src]="cardTypeImage"
        alt="Card Type Icon"
        width="42"
        height="42"
        *ngIf="cardTypeImage && cardTypeImage !== cardImages['Unknown']"
      />
      <mat-icon
        *ngIf="!cardTypeImage || cardTypeImage === cardImages['Unknown']"
      >
        <i class="healent-component-65-2 primary-color"></i>
      </mat-icon>
    </div>
    <mat-error style="font-size: 12px">Valid card number required</mat-error>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Expiration date</mat-label>
    <input
      matInput
      [formControl]="expirationDate"
      placeholder="MM/YY"
      (input)="onExpirationDateInput($event)"
      maxlength="5"
      required
      type="text"
      inputmode="numeric"
    />
    <div matSuffix tabindex="-1" class="p-r-m">
      <mat-icon>
        <i class="healent-form-input-icon-2 primary-color"></i>
      </mat-icon>
    </div>
    <mat-error style="font-size: 12px"
      >Valid expiration date required</mat-error
    >
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Security code</mat-label>
    <input
      matInput
      [formControl]="securityCode"
      [placeholder]="securityPlaceholder"
      [maxlength]="securityMaxLength"
      type="text"
      inputmode="numeric"
      pattern="\d*"
      (input)="onInputCode($event)"
      required
    />
    <div matSuffix tabindex="-1" class="p-r-m">
      <mat-icon>
        <i class="healent-component-64-2 primary-color"></i>
      </mat-icon>
    </div>
    <mat-error style="font-size: 12px">Valid security code required</mat-error>
  </mat-form-field>
</div>
